import IClientApp from "@/interfaces/IClientApp";
import IState from "@/interfaces/IState";
import { ActionContext } from "vuex";

export default async (
  context: ActionContext<IState, IState>,
  clientAppData: IClientApp
) => {
  if (!clientAppData) {
    return Promise.reject("Incorrect client app data");
  }
  try {
    const createClientApp = await context.dispatch("backendTalker", {
      request: "subscriptions_client_app_create",
      data: clientAppData,
    });

    return createClientApp;
  } catch (err) {
    throw new Error(err);
  }
};
